import React from 'react';
import { Badge, type BadgeProps } from '@/lib/components/ui/badge';
import { certifications } from 'modules/User/models/constants';

export type BadgeCertificationProps = Omit<BadgeProps, 'children'> & {
  value: string;
};

const BadgeCertification: React.FC<BadgeCertificationProps> = ({ value, ...props }) => {
  const label = certifications.find((c) => c.value === value)?.label || value;
  const emoji = value === 'qualiopi' ? '📜' : value === 'coaching' ? '🧑‍🏫' : value === 'bilan-de-competence' ? '📊' : '🏅';
  return (
    <Badge variant={props.variant || 'outline-ghost'} size={props.size || 'sm'} {...props}>
      <span className="mr-1">{emoji}</span>
      {label}
    </Badge>
  );
};

export default BadgeCertification;
